export default "<div id=\"vueUserDetails\">\n  <user-details :route=\"route\"></user-details>\n</div>";